var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.confirmLoading } },
    [
      _c(
        "j-form-container",
        { attrs: { disabled: _vm.formDisabled } },
        [
          _c(
            "a-form-model",
            {
              ref: "form",
              attrs: {
                slot: "detail",
                model: _vm.model,
                rules: _vm.validatorRules
              },
              slot: "detail"
            },
            [
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    label: _vm.language["gift_tag_name"],
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "label"
                  }
                },
                [
                  _c("a-input", {
                    attrs: {
                      placeholder:
                        _vm.language["common.pleaseInput"] +
                        _vm.language["gift_tag_name"]
                    },
                    model: {
                      value: _vm.model.label,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "label", $$v)
                      },
                      expression: "model.label"
                    }
                  })
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    label: _vm.language["gift_tag_group"],
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "groupName"
                  }
                },
                [
                  _c("j-dict-select-tag", {
                    attrs: {
                      placeholder:
                        _vm.language["common.pleaseChoose"] +
                        _vm.language["gift_tag_group"],
                      type: _vm.list,
                      dictCode: "gift_tag"
                    },
                    model: {
                      value: _vm.model.groupName,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "groupName", $$v)
                      },
                      expression: "model.groupName"
                    }
                  })
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    label: _vm.language["gift_user_app"],
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "app"
                  }
                },
                [
                  _c("a-select", {
                    attrs: {
                      placeholder:
                        _vm.language["common.pleaseChoose"] +
                        _vm.language["gift_user_app"],
                      options: _vm.appList,
                      disabled: _vm.isDisabled
                    },
                    on: { change: _vm.handlerApp },
                    model: {
                      value: _vm.model.app,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "app", $$v)
                      },
                      expression: "model.app"
                    }
                  })
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    label: _vm.language["common.sort"],
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "sort"
                  }
                },
                [
                  _c("a-input", {
                    model: {
                      value: _vm.model.sort,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "sort", $$v)
                      },
                      expression: "model.sort"
                    }
                  })
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    label: _vm.language["serial.activeFlag"],
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol
                  }
                },
                [
                  _c("j-switch", {
                    on: { change: _vm.changeSwitch },
                    model: {
                      value: _vm.model.status,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "status", $$v)
                      },
                      expression: "model.status"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }